'use strict';

var _arrow = require('./types/arrow');

var _arrow2 = _interopRequireDefault(_arrow);

var _arrowReverse = require('./types/arrow-reverse');

var _arrowReverse2 = _interopRequireDefault(_arrowReverse);

var _arrowAlt = require('./types/arrow-alt');

var _arrowAlt2 = _interopRequireDefault(_arrowAlt);

var _arrowAltReverse = require('./types/arrow-alt-reverse');

var _arrowAltReverse2 = _interopRequireDefault(_arrowAltReverse);

var _arrowTurn = require('./types/arrow-turn');

var _arrowTurn2 = _interopRequireDefault(_arrowTurn);

var _arrowTurnReverse = require('./types/arrow-turn-reverse');

var _arrowTurnReverse2 = _interopRequireDefault(_arrowTurnReverse);

var _boring = require('./types/boring');

var _boring2 = _interopRequireDefault(_boring);

var _collapse = require('./types/collapse');

var _collapse2 = _interopRequireDefault(_collapse);

var _collapseReverse = require('./types/collapse-reverse');

var _collapseReverse2 = _interopRequireDefault(_collapseReverse);

var _elastic = require('./types/elastic');

var _elastic2 = _interopRequireDefault(_elastic);

var _elasticReverse = require('./types/elastic-reverse');

var _elasticReverse2 = _interopRequireDefault(_elasticReverse);

var _emphatic = require('./types/emphatic');

var _emphatic2 = _interopRequireDefault(_emphatic);

var _minus = require('./types/minus');

var _minus2 = _interopRequireDefault(_minus);

var _perspectiveX = require('./types/perspective-x');

var _perspectiveX2 = _interopRequireDefault(_perspectiveX);

var _perspectiveXReverse = require('./types/perspective-x-reverse');

var _perspectiveXReverse2 = _interopRequireDefault(_perspectiveXReverse);

var _perspectiveY = require('./types/perspective-y');

var _perspectiveY2 = _interopRequireDefault(_perspectiveY);

var _perspectiveYReverse = require('./types/perspective-y-reverse');

var _perspectiveYReverse2 = _interopRequireDefault(_perspectiveYReverse);

var _perspectiveXY = require('./types/perspective-x-y');

var _perspectiveXY2 = _interopRequireDefault(_perspectiveXY);

var _perspectiveXYReverse = require('./types/perspective-x-y-reverse');

var _perspectiveXYReverse2 = _interopRequireDefault(_perspectiveXYReverse);

var _slider = require('./types/slider');

var _slider2 = _interopRequireDefault(_slider);

var _sliderReverse = require('./types/slider-reverse');

var _sliderReverse2 = _interopRequireDefault(_sliderReverse);

var _spin = require('./types/spin');

var _spin2 = _interopRequireDefault(_spin);

var _spinReverse = require('./types/spin-reverse');

var _spinReverse2 = _interopRequireDefault(_spinReverse);

var _spring = require('./types/spring');

var _spring2 = _interopRequireDefault(_spring);

var _springReverse = require('./types/spring-reverse');

var _springReverse2 = _interopRequireDefault(_springReverse);

var _squeeze = require('./types/squeeze');

var _squeeze2 = _interopRequireDefault(_squeeze);

var _stand = require('./types/stand');

var _stand2 = _interopRequireDefault(_stand);

var _standReverse = require('./types/stand-reverse');

var _standReverse2 = _interopRequireDefault(_standReverse);

var _vortex = require('./types/vortex');

var _vortex2 = _interopRequireDefault(_vortex);

var _vortexReverse = require('./types/vortex-reverse');

var _vortexReverse2 = _interopRequireDefault(_vortexReverse);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = {
  Arrow: _arrow2.default,
  ArrowReverse: _arrowReverse2.default,
  ArrowAlt: _arrowAlt2.default,
  ArrowAltReverse: _arrowAltReverse2.default,
  ArrowTurn: _arrowTurn2.default,
  ArrowTurnReverse: _arrowTurnReverse2.default,
  Boring: _boring2.default,
  Collapse: _collapse2.default,
  CollapseReverse: _collapseReverse2.default,
  Elastic: _elastic2.default,
  ElasticReverse: _elasticReverse2.default,
  Emphatic: _emphatic2.default,
  Minus: _minus2.default,
  PerspectiveX: _perspectiveX2.default,
  PerspectiveXReverse: _perspectiveXReverse2.default,
  PerspectiveY: _perspectiveY2.default,
  PerspectiveYReverse: _perspectiveYReverse2.default,
  PerspectiveXY: _perspectiveXY2.default,
  PerspectiveXYReverse: _perspectiveXYReverse2.default,
  Slider: _slider2.default,
  SliderReverse: _sliderReverse2.default,
  Spin: _spin2.default,
  SpinReverse: _spinReverse2.default,
  Spring: _spring2.default,
  SpringReverse: _springReverse2.default,
  Squeeze: _squeeze2.default,
  Stand: _stand2.default,
  StandReverse: _standReverse2.default,
  Vortex: _vortex2.default,
  VortexReverse: _vortexReverse2.default
};